// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/store";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./config/msalConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { LoadScript } from "@react-google-maps/api";
import { GOOGLE_MAPS_API_KEY } from "./config/Constant";

const root = ReactDOM.createRoot(document.getElementById("root"));

const pca = new PublicClientApplication(msalConfig);
root.render(
  <Provider store={store}>
    <MsalProvider instance={pca}>
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <LoadScript
            googleMapsApiKey={GOOGLE_MAPS_API_KEY}
            libraries={["places"]}
            loadingElement={<></>} // Hide loader completely
          >
            <App />
          </LoadScript>
          <ToastContainer autoClose={3000} limit={1} />
        </BrowserRouter>
      </PersistGate>
    </MsalProvider>
  </Provider>
);

export default store; // Exporting store directly if needed elsewhere
